import {initSlider} from "../../components/page-product/initSlider";
import {AutoLoading} from "./AutoLoading";
import {add2Basket} from "./add2basket";
import {forEach} from "../helpers";

export class AutoLoadingProductCard extends AutoLoading{

  constructor($wrapper, type) {
    super($wrapper, type)
  }

  actions(button, html) {
    this.setHtml(html);
    this.initSlider();
    forEach(document.querySelectorAll('.js-add-to-basket'), $button => {
      $button.addEventListener('click', () => {
        new add2Basket($button, document.querySelector('.js-quantity-input')).init();
      });
    });
    this.loading(false);
  }

  setHtml(html) {
    this.$container.innerHTML = html;
    this.init();
  }

  initSlider() {
    initSlider(this.$container)
  }

}
